// extracted by mini-css-extract-plugin
module.exports = {"text":"EllipsisWithTooltip_text__HBnqL"};